import { HistoryDataSourceResponse } from 'src/app/proto/generated/inv_history_service_pb';
import { HistoryModel } from './history.model';

export class HistoryDataSourceModel {
  data: HistoryModel[] = [];
  total = 0;

  static Mapper(source: HistoryDataSourceResponse): HistoryDataSourceModel {
    const destination = new HistoryDataSourceModel();
    destination.data = HistoryModel.MapperList(source.getDataList());
    destination.total = source.getTotal();
    return destination;
  }
}
